import React from 'react';
import { map, get, find } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col } from 'react-bootstrap';

import { updateData } from 'actions/updateData';
import { optionsPosada } from 'constants/global';
import firebase  from 'firebase.js';

import './index.less';

const mapStateToProps = ({ runtime }) => ({
  items: get(runtime, 'itemsData') || [],
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateData }, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
export default class ListAll extends React.Component {
  // state = { posada: 1 };
  
  componentDidMount() {
    const itemsRef = firebase.database().ref('/items');
    itemsRef.on('value', snapshot => {
      const items = snapshot.val();
      const newState = [];
      map(items, (item, id) => {
        if (item.type === this.props.type) {
          item.id = id;
          newState.push(item);
        }
      });
      this.props.updateData(newState, 'items');
    });
    //   this.changePosada(this.state.posada);
  }
  //
  // changePosada = value => {
  //   this.setState({ posada: value });
  //   this.props.updateData([], 'items');
  //   const itemsRef = firebase.database().ref(`/posada/${value}`);
  //   itemsRef.on('value', snapshot => {
  //     const items = snapshot.val();
  //     const newState = [];
  //     map(items, (item, id) => {
  //       if (item.type === this.props.type) {
  //         item.id = id;
  //         newState.push(item);
  //       }
  //     });
  //     this.props.updateData(newState, 'items');
  //   });
  // };
  
  getPosada = item => find(optionsPosada, { value: item }).label;
  
  render () {
    return (
      <div className="list">
        <Row className="item item-title">
          <Col xs={1}>
            <div className="item_name">№</div>
          </Col>
          <Col xs={4}>
            <div className="item_name">Прізвище та ім'я</div>
          </Col>
          <Col xs={3}>
            <div className="item_description">Посада</div>
          </Col>
          <Col xs={3}>
            <div className="item_description">Коротка біографія</div>
          </Col>
          <Col xs={1}>
            <div className="item_description">Відео</div>
          </Col>
        </Row>
        {
          this.props.items.length ?
          this.props.items.map((item, i) => (
            <Row className="item" key={item.id}>
              <Col xs={1}>
                <div className="item_name">{i+1}</div>
              </Col>
              <Col xs={4}>
                <div className="item_name">{item.name}</div>
              </Col>
              <Col xs={3}>
                <div className="item_description">{this.getPosada(item.posada)} {item.posada === 12 && '| ' + item.opys}</div>
              </Col>
              <Col xs={3}>
                <div className="item_description">{item.bio}</div>
              </Col>
              <Col xs={1}>
                <div className="item_description"><a href={item.video}>Відео</a></div>
              </Col>
            </Row>
          )) :
            <div className="no-results">Немає записів</div>
        }
      </div>
    );
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/listAll/index.js